import axios from 'axios';

const API_URL = 'http://localhost:52865/api/Auth/';

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'login', {
        username: user.username,
        password: user.password
      })
      .then(this.handleResponse)
      .then(response => {
        if (response.data) {
          localStorage.setItem('user', JSON.stringify(response.data));
          
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }
  update(id,user) {
    return axios.post(API_URL + id, {
      userName: user.username,
      lastName: user.lastname,
      firstName: user.firstname
    });
  }

  register(user) {
    return axios.put(API_URL + 'register', {
      username: user.username,
      lastname: user.lastname,
      firstname: user.firstname,
      password: user.password
    });
  }

  handleResponse(response) {
    if (response.status === 401) {
      this.logout();
      location.reload(true);

      const error = response.data && response.data.message;
      return Promise.reject(error);
    }

    return Promise.resolve(response);
  }
}

export default new AuthService();
